<template>
    <div class="custom-select">
        <div class="edit-table">
            <div class="title_2">费用清单</div>
            <vxe-toolbar v-if="!disabled" style="margin-left: 125px;">
                <template v-slot:buttons>
                    <vxe-button @click="openModal()">添加费用清单</vxe-button>
                    <vxe-button @click="clearFn()">清空</vxe-button>
                </template>
            </vxe-toolbar>
            <vxe-table :data="listOne" style="margin-left: 125px;">
                <vxe-table-column min-width="100" field="createDateAll" title="创建时间"></vxe-table-column>
                <vxe-table-column min-width="100" field="channelFeeName" title="渠道费用名称"></vxe-table-column>
                <vxe-table-column min-width="100" field="channelCash" title="金额"></vxe-table-column>
                <vxe-table-column min-width="100" field="productName" title="商品名称"></vxe-table-column>
                <vxe-table-column min-width="100" field="productCode" title="商品编码"></vxe-table-column>
                <vxe-table-column min-width="100" field="orderCode" title="需货单号"></vxe-table-column>
                <vxe-table-column min-width="100" field="channelNum" title="数量"></vxe-table-column>
                <vxe-table-column min-width="100" field="effectiveDate" title="生效时间"></vxe-table-column>
                <vxe-table-column min-width="100" field="feeType" title="费用类型">
                    <template #default="{ row }">
                        <span v-if="row.feeType === 'month'">月度</span>
                        <span v-else-if="row.feeType === 'season'">季度</span>
                        <span v-else-if="row.feeType === 'year'">年度</span>
                    </template>
                    <!-- month-月度 season-季度 year-年度 -->
                </vxe-table-column>
                <vxe-table-column min-width="100" field="channelFeeCode" title="渠道费用编码"></vxe-table-column>
                <vxe-table-column min-width="100" field="isSupplyBill" title="是否开票">
                    <template #default="{ row }">
                        <span v-if="row.isSupplyBill === 'Y'">是</span>
                        <span v-else>否</span>
                    </template>
                </vxe-table-column>
                <vxe-column title="操作" width="80" v-if="!disabled">
                    <template #default="{ row, rowIndex }">
                        <template>
                            <span @click="deletRow(row, rowIndex)" style="color: red; cursor: pointer">删除</span>
                        </template>
                    </template>
                </vxe-column>
            </vxe-table>
            <div class="title_2">货补池信息</div>
            <vxe-table :data="listTwo" style="margin-left: 125px;">
                <vxe-table-column min-width="100" field="channelFeeCode" title="渠道费用编码"></vxe-table-column>
                <vxe-table-column min-width="100" field="feeType" title="费用类型">
                    <template #default="{ row }">
                        <span v-if="row.feeType === 'month'">月度</span>
                        <span v-else-if="row.feeType === 'season'">季度</span>
                        <span v-else-if="row.feeType === 'year'">年度</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column min-width="100" field="orderCode" title="需货单号"></vxe-table-column>
                <vxe-table-column min-width="100" field="fiscalYear" title="财年"></vxe-table-column>
                <vxe-table-column min-width="100" field="custName" title="经销商名称"></vxe-table-column>
                <vxe-table-column min-width="200" field="companyName" title="公司主体">
                    <template #default="{ row, rowIndex }">
                        <el-select v-model="row.companyName" @change="companyChange($event, rowIndex)"
                            placeholder="公司主体" :disabled="disabled">
                            <el-option v-for="item in companyList" :key="item.companyCode"
                                :label="item.companyName" :value="item.companyCode">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column min-width="100" field="productName" title="商品名称"></vxe-table-column>
                <vxe-table-column min-width="100" field="transformCash" title="划转金额"></vxe-table-column>
                <vxe-table-column min-width="100" field="unitPrice" title="产品单价"></vxe-table-column>
                <vxe-table-column min-width="100" field="transformNum" title="划转数量"></vxe-table-column>
                <vxe-table-column min-width="100" field="unit" title="单位">瓶</vxe-table-column>
            </vxe-table>
        </div>
        <!-- 弹框 -->
        <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
    </div>
</template>

<script>

import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import request from '@/found/utils/request';

export default {
  name: 'product_list',
  props: {
    value: [Array, Object],
    disabled: Boolean,

  },
  data() {
    return {
      listOne: [],
      listTwo: [],
      companyList: [],
      // state: '',
    };
  },
  components: {
    SelectConfig,
  },
  created() {
    this.getCompanyList();
  },
  watch: {
    value: {
      handler(val) {
        console.log(val);
        if (val) {
          this.listOne = val.listOne || [];
          this.listTwo = val.listTwo || [];
        } else {
          this.listOne = [];
          this.listTwo = [];
        }
      },
    },
  },
  methods: {
    companyChange(row, index) {
      console.log(row, index);
      this.$set(this.listTwo[index], 'companyCode', row);
      const res = this.companyList.find(
        (item) => item.companyCode === row,
      );
      this.$set(this.listTwo[index], 'companyName', res.companyName);
      const pars = {
        channelFeeCode: this.listTwo[index].channelFeeCode,
        companyCode: row,
      };
      request.post('/dms/dmschanneltransform/findTransFormInfo', pars).then((rel) => {
        if (rel.success) {
          console.log(rel);
          this.$set(this.listTwo[index], 'transformCash', rel.result.transformCash);
          this.$set(this.listTwo[index], 'unitPrice', rel.result.unitPrice);
          this.$set(this.listTwo[index], 'transformNum', rel.result.transformNum);
        } else {
          this.$set(this.listTwo[index], 'transformCash', null);
          this.$set(this.listTwo[index], 'unitPrice', null);
          this.$set(this.listTwo[index], 'transformNum', null);
        }
      }).catch((err) => {
        console.log('err', err);
        this.$set(this.listTwo[index], 'transformCash', null);
        this.$set(this.listTwo[index], 'unitPrice', null);
        this.$set(this.listTwo[index], 'transformNum', null);
      });
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
      console.log(this.listTwo);
    },
    getCompanyList() {
      request.post('/mdm/companyInfo/companyPageList ', { flagBan: '1', pageNum: 1, pageSize: 1000 }).then((res) => {
        console.log(res);
        if (res.success) {
          this.companyList = res.result.data || [];
        }
      });
    },
    // 新增弹窗
    openModal() {
      const params = {
        functionCode: 'poollList',
        data: this.listOne || [],
        idKey: 'channelFeeCode',
        paramData: {
          enableStatus: '009',
        },
      };
      params.noReset = true;
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 选择回调
    onGetSelect(val) {
      console.log(val);
      val.forEach((it) => {
        const itt = it;
        itt.companyName = null;
        itt.companyCode = null;
      });
      this.listOne = val;
      this.listTwo = val;
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    // 清除选择
    clearFn() {
      this.listOne = [];
      this.listTwo = [];
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
    deletRow(row, index) {
      console.log(row, index);
      const feeCode = row.channelFeeCode;
      const indexOne = this.listOne.findIndex((item) => item.channelFeeCode === feeCode);
      //   const indexTwo = this.listTwo.findIndex((item) => item.channelFeeCode === feeCode);

      if (indexOne > -1) {
        this.listOne.splice(indexOne, 1);
      }
      //   if (indexTwo > -1) {
      //     this.listTwo.splice(indexTwo, 1);
      //   }
      this.$emit('input', { listOne: this.listOne, listTwo: this.listTwo });
      this.$emit('change', { listOne: this.listOne, listTwo: this.listTwo });
    },
  },
};
</script>

<style lang="less" scoped>
.title_2 {
font-size: 16px;
    height: 20px;
    line-height: 20px;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 18px;
}
.edit-table{
    margin-left: 0 !important;
}
</style>
